export default __webpack_public_path__ + "static/media/Flaticon2.59719087.eot";